import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import activity from './activity'
import area from './area'
import auth from './auth'
import developer from './developer'
import customer from './customer'
import dashboard from './dashboard'
import employee from './employee'
import menu from './menu'
import permissions from './permissions'
import brand from './brand'
import segment from './segment'
import category from './category'
import instrument from './instrument'
import bundling from './bundling'
import selling from './selling'
import prospekBank from './prospek-bank'
import banner from './banner'
import ticket from './ticket'
import agreement from './agreement'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'cms',
  storage: window.localStorage
  // reducer: state => ({
  //   auth: state.auth,
  //   permissions: state.permissions,
  //   activity: state.activity,
  //   prospekBank: state.prospekBank,
  //   dashboard: state.dashboard,
  //   customer: state.customer
  // })
})

const store = new Vuex.Store({
  modules: {
    auth,
    permissions,
    area,
    employee,
    menu,
    activity,
    customer,
    dashboard,
    developer,
    brand,
    segment,
    category,
    instrument,
    bundling,
    prospekBank,
    selling,
    banner,
    ticket,
    agreement
  },
  plugins: [vuexLocalStorage.plugin]
})

export default store
